import LOADER from '../../assets/preloader/loader.gif'

const PlatformLoader: React.FC = (): JSX.Element => {
    return <img className="preloader" src={LOADER} alt="loading..." />
}

export default PlatformLoader
